export default __webpack_public_path__ + "static/media/back-music.52739c53.mp3";